import { render, staticRenderFns } from "./SchoolOverallLetterGrade.vue?vue&type=template&id=8dcda8a8&scoped=true&"
import script from "./SchoolOverallLetterGrade.vue?vue&type=script&lang=ts&"
export * from "./SchoolOverallLetterGrade.vue?vue&type=script&lang=ts&"
import style0 from "./SchoolOverallLetterGrade.vue?vue&type=style&index=0&id=8dcda8a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dcda8a8",
  null
  
)

export default component.exports